import styled from 'styled-components'

const Logo = styled.img.attrs(props=> ({
  alt:  props.alt,
  src: props.src,
  style: props.style
}))`
  max-width: 100%;
  max-height: 40px;
`

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo/index.js